import CAModal from '@ds/components/containers/CAModal'
import type { CAModalSize, CAModalStyle } from '@ds/interfaces'
import { useGlobalStore } from '@vuejs/stores/GlobalStore'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
	name: 'ConfirmationDialog',

	props: {
		additionalClasses: { default: '', type: String },
		byPassEmittedEvent: { default: false, type: Boolean },
		buttonsDirection: { default: 'row', type: String as PropType<'column' | 'row'> },
		dataTest: { default: '', type: String },
		enableFooter: { default: true, type: Boolean },
		modalSize: { default: 'small', type: String as PropType<CAModalSize> },
		modalStyle: { default: 'success', type: String as PropType<CAModalStyle> },
		name: { required: true, type: String },
		reconfirm: { default: false, type: Boolean },
		showCancelButton: { default: true, type: Boolean },
		showSubmitButton: { default: true, type: Boolean },
		submitText: { default: 'Confirm', type: String },
	},

	emits: [
		'cancel',
		'confirm',
		'reconfirm',
	],

	computed: {
		globalStore(): ReturnType<typeof useGlobalStore> {
			return useGlobalStore()
		},
	},

	methods: {
		onCloseModal() {
			this.$emit('cancel')
			this.globalStore.resetCAModal()
		},

		onHandleConfirm() {
			if (this.reconfirm) {
				this.$emit('reconfirm')
			} else {
				this.$emit('confirm')
			}
		},
	},

	render() {
		return (
			<CAModal
				additionalClasses={`ca-modal__confirmation-dialog ${this.additionalClasses}`}
				buttonsDirection={this.buttonsDirection}
				dataTest={this.dataTest}
				enableFooter={this.enableFooter}
				isOpen={this.globalStore.emittedEvent === this.name || this.byPassEmittedEvent}
				modalSize={this.modalSize}
				modalStyle={this.modalStyle}
				showCancelButton={this.showCancelButton}
				showSubmitButton={this.showSubmitButton}
				submitText={this.submitText}
				title="Are you sure?"
				onCancel={this.onCloseModal}
				onSubmit={this.onHandleConfirm}
			>
				{this.$slots.default?.()}
			</CAModal>
		)
	},
})
